// Core
import { initConfig } from './core/config';
import { initLayout } from './core/layout';
import { initThemeToggle, updateHtmlAttributes } from './core/theme';

// Form Components
import { initEnterBindings } from './components/forms/bind-enter';
import { initChoices } from './components/forms/choices';
import { initPincode } from './components/forms/pincode';
import { initTextCounter } from './components/forms/textcounter';
import { initInputSpinner } from './components/forms/input-spinner';
import { initMultiSelect } from './components/forms/multi-select';
import { initInputMask } from './components/forms/inputmask';

// Initialize Core
const config = initConfig();
updateHtmlAttributes(document.documentElement, config);
initLayout();
initThemeToggle();

// jQueryに依存しないコンポーネントを即座に初期化
initChoices();
initInputSpinner();
initInputMask();

// jQueryに依存するコンポーネントをDOMContentLoadedイベントで初期化
document.addEventListener('DOMContentLoaded', function() {
    // jQueryが利用可能かチェック
    if (typeof window.jQuery !== 'undefined') {
        initEnterBindings();
        initMultiSelect();
        initTextCounter();
        initPincode();
    } else {
        // jQueryがまだ読み込まれていない場合は少し待機
        setTimeout(() => {
            initEnterBindings();
            initMultiSelect();
            initTextCounter();
            initPincode();
        }, 100);
    }
});

window.initForms = (elem) => {
    initEnterBindings(elem);
    initChoices(elem);
    initInputSpinner(elem);
    initInputMask(elem);
    initEnterBindings(elem);
    initMultiSelect(elem);
    initTextCounter(elem);
    initPincode(elem);
}
